import { ControlsSetting } from '../abstractions/controls-setting';
import { FormComponent } from '../components/form/form.component';
import { PageComponent } from '../components/page/page.component';
import { PanelComponent } from '../components/panel/panel.component';
import { PercentComponent } from '../components/percent/percent.component';
import { QuestionComponent } from '../components/question/question.component';
import { TextfieldQuestionComponent } from '../components/textfield-question/textfield-question.component';
import { YesNoComponent } from '../components/yes-no/yes-no.component';

export const controlsSettingBase: ControlsSetting = {
  boolean: YesNoComponent,
  page: PageComponent,
  percent: PercentComponent,
  textfield: TextfieldQuestionComponent,
  panel: PanelComponent,
  question: QuestionComponent,
  form: FormComponent,
};
